// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const ChevronToggleIcon: Icon = ({ size = 16, color, variant: _variant, className, style, ...rest }) => {
  const stroke = color || 'currentColor';
  return (
    <svg
      width={size}
      height={(typeof size === 'number' ? size : Number(size) || 16) * (10 / 16)}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="chevron toggle"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M1 6.5L6 1.5L11 6.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export { ChevronToggleIcon };
